import { KeycloakLoginOptions } from 'keycloak-js'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import keycloak from './keycloack'
// import { getFirestoreCustomToken } from './keycloakApis'
import { IKeyCloakProvider, IKeyCloakProviderState } from './types'
// import Firebase, { runUserFirestoreSignInProcess } from './../firebase/Firebase'
// import { Unsubscribe } from 'firebase/auth'
export const KeyCloakContext = React.createContext<IKeyCloakProvider>({})
const KeyCloakProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  // const refAuthStateSubscriber = useRef<Unsubscribe | null>(null)
  const [contextState, setContextState] = useState<IKeyCloakProviderState>({
    keyCloakUser: null,
    isKeycloakInit: false,
    isLoging: false,
    isAuthenticated: false
  })
  const getAlreadyLoginUser = () => {
    try {
      let ssoInfo = localStorage.getItem('sso')
      if (ssoInfo !== null && ssoInfo !== undefined) {
        const decodeUser = JSON.parse(atob(ssoInfo))
        setContextState((prevState) => ({
          ...prevState,
          ...decodeUser
        }))
      }
    } catch (error) {}
  }
  const setUserToStorage = (userInfo: any) => {
    try {
      if (userInfo !== null && userInfo !== undefined) {
        const encodedUser = btoa(JSON.stringify(userInfo))
        localStorage.setItem('sso', encodedUser)
      } else {
        localStorage.removeItem('sso')
      }
    } catch (error) {}
  }
  const doLogin = (options?: KeycloakLoginOptions | null): void => {
    setContextState((prevState) => ({
      ...prevState,
      isLoging: true
    }))
    if (options) {
      // eslint-disable-next-line
      keycloak?.login(options)
    } else {
      // eslint-disable-next-line
      keycloak?.login()
    }
  }
  const doLogout = async (): Promise<void> => {
    if (keycloak.authenticated === true) {
      if (keycloak.isTokenExpired(120)) {
        await keycloak.updateToken(120)
      }
      await keycloak?.logout()
    }
    setContextState((prevState) => ({ ...prevState, keyCloakUser: null }))
    setUserToStorage(null)
    // Firebase.logoutUser()
  }
  const updateKeyCloakToken = async () => {
    setContextState((prevState) => ({
      ...prevState,
      keyCloakUser: {
        ...(prevState.keyCloakUser ?? {}),
        refreshToken: keycloak.refreshToken,
        accessToken: keycloak.token
      }
    }))
  }

  const getUserProfile = async () => {
    // const firestoreCustomToken = await getFirestoreCustomToken(keycloak.token ?? '')
    const currentUser = await keycloak.loadUserProfile()
    if (currentUser !== undefined && currentUser !== null) {
      try {
        // const userResponce = await Firebase.signInWithCustomToken(firestoreCustomToken)
        setContextState((prevState) => ({
          ...prevState,
          isKeycloakInit: true,
          isAuthenticated: keycloak.authenticated,
          isLoging: false,
          keyCloakUser: {
            ...currentUser,
            refreshToken: keycloak.refreshToken,
            accessToken: keycloak.token
            // firestoreRefreshToken: userResponce?.firestoreRefreshToken ?? null,
            // firestoreToken: userResponce?.firestoreToken ?? null,
            // firestoreCustomToken: firestoreCustomToken
          }
        }))
        setUserToStorage({
          keyCloakUser: {
            ...currentUser,
            refreshToken: keycloak.refreshToken,
            accessToken: keycloak.token
            // firestoreRefreshToken: userResponce?.firestoreRefreshToken ?? null,
            // firestoreToken: userResponce?.firestoreToken ?? null,
            // firestoreCustomToken: firestoreCustomToken
          }
        })
      } catch (error: any) {
        setContextState((prevState) => ({
          ...prevState,
          isKeycloakInit: true,
          isAuthenticated: keycloak.authenticated,
          isLoging: false,
          keyCloakUser: {
            ...currentUser,
            refreshToken: keycloak.refreshToken,
            accessToken: keycloak.token
          }
        }))
        setUserToStorage({
          keyCloakUser: {
            ...currentUser,
            refreshToken: keycloak.refreshToken,
            accessToken: keycloak.token
          }
        })
      }
    }
  }

  useEffect(() => {
    if (keycloak !== null) {
      keycloak.onAuthLogout = () => {
        console.log('keycloak--->> onAuthLogout')
        doLogout()
      }

      keycloak.onTokenExpired = () => {
        console.log('keycloak--->> onTokenExpired')
        keycloak
          .updateToken(0)
          .then(() => {
            console.log('keycloak--->> Token Refreshed')
            // eslint-disable-next-line
            updateKeyCloakToken()
          })
          .catch(() => {
            doLogout()
          })
      }
    }
  }, [keycloak])

  useEffect(() => {
    getAlreadyLoginUser()
    // Keycloak init failure case timout
    setTimeout(() => {
      setContextState((prevState) => ({ ...prevState, isKeycloakInit: true, isLoging: false }))
    }, 20000)
    // Init keycloak
    keycloak
      .init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        pkceMethod: 'S256'
      })
      .then((authenticated: any) => {
        // console.log('authenticated:', authenticated)
        if (authenticated) {
          setContextState((prevState) => ({
            ...prevState,
            isLoging: true,
            isAuthenticated: authenticated
          }))
          getUserProfile()
        } else {
          setContextState((prevState) => ({
            ...prevState,
            isKeycloakInit: true,
            isLoging: false,
            isAuthenticated: authenticated
          }))
          doLogout()
        }
      })
      .catch((error: any) => {
        setContextState((prevState) => ({
          ...prevState,
          isKeycloakInit: true,
          isLoging: false,
          isAuthenticated: false
        }))
        doLogout()
      })
  }, [])

  // useEffect(() => {
  //   if (refAuthStateSubscriber.current == null) {
  //     if (
  //       getFirestoreConfigs !== null &&
  //       getFirestoreConfigs !== undefined &&
  //       contextState?.keyCloakUser?.id !== null &&
  //       contextState?.keyCloakUser?.id !== undefined &&
  //       contextState?.keyCloakUser?.firestoreCustomToken !== undefined &&
  //       contextState?.keyCloakUser?.firestoreCustomToken !== null
  //     ) {
  //       let firestoreConfigs = getFirestoreConfigs()
  //       refAuthStateSubscriber.current = Firebase.setupFirebaseAuthStateChangeListener(
  //         firestoreConfigs,
  //         (user) => {
  //           runUserFirestoreSignInProcess(contextState?.keyCloakUser?.firestoreCustomToken ?? '')
  //             .then((userResponce) => {
  //               if (userResponce && contextState.keyCloakUser) {
  //                 setUserToStorage({
  //                   keyCloakUser: {
  //                     ...contextState.keyCloakUser,
  //                     firestoreRefreshToken: userResponce.firestoreRefreshToken ?? null,
  //                     firestoreToken: userResponce.firestoreToken ?? null
  //                   }
  //                 })
  //               }
  //             })
  //             .catch(() => {})
  //         }
  //       )
  //     }
  //   }
  //   return () => {
  //     refAuthStateSubscriber.current?.()
  //     refAuthStateSubscriber.current = null
  //   }
  // }, [contextState?.keyCloakUser?.id, contextState?.keyCloakUser?.firestoreCustomToken])

  return (
    <KeyCloakContext.Provider value={{ contextState, doLogout, doLogin }}>
      {children}
    </KeyCloakContext.Provider>
  )
}
export default KeyCloakProvider
